import { createApi } from '@reduxjs/toolkit/query/react';

import { POSTGREST_BASE_URL } from '@/requests';

import { PostgrestApiTags as TAGS } from '../store.constants';
import { createBaseQueryWithLock } from '../store.utils';

export const postgrestApi = createApi({
  reducerPath: 'postgrestApi',
  baseQuery: createBaseQueryWithLock({ baseUrl: POSTGREST_BASE_URL }),
  tagTypes: Object.values(TAGS),
  endpoints: () => ({}),
});
